import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Lable from '@material-ui/core/FormLabel';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import Captcha from './ClientCaptchaComponent';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Moratorium from './MoratoriumComponent';
import Extension from './ExtensionComponent';
import SucessDialog from '../alert/SucessPopupBox'
import ErrorDialog from '../alert/ErrorPopupBox'
import '../../css/styles.css'
import Pulse from '../../images/Pulse.gif';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';



class ReliefFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            moratorium: false,
            extension: false,
            name: "",
            nic: "",
            mobileNumber: "",
            email: "",
            profession: "",
            //nameofbusiness: "",
            accno: "",
            otherInfo: "",
            branchName: "",
            branchId: "",
            circular:"",
            wave:"",
            typeoffacilities: {
                pl: false,
                hl: false,
                pen: false,
                lease: false,
                otherLoans: false,
                tl: false,
                stl: false,
                idl: false,
                otherBusinessLoans: false,
                overdrafts: false

            },
            moratoriumList: {
                capital: false,
                interest: false,
                capital_interest: false
            },
            reliefMeasure:{
                reason1:false,
                reason2: false,
                reason3: false,
                reason4: false,
                otherReasons:""

            },
            moratoriumMonths: "",
            extensionMonths: "",

            captcha: "",
            captchaCode: "",

            helperText: "",
            error: false,
            captchaValid: true,

            branchHelperText: "",
            branchError: false,

            validfacility: false,

            validMoratatium: false,
            validExtension: false,

            facilityErrorLable: false,
            reqTypeErrorLable: false,
            reliefMeasureErrorLable: false,
            selRadioValue: ''


        }
    }
    validateMoratatium = () => {

        if (this.state.moratorium && (this.state.moratorium != 0 || this.state.moratorium != "") &&
            this.state.moratoriumList.capital || this.state.moratoriumList.interest || this.state.moratoriumList.capital_interest) {
            return true;
        } else {
            return false;
        }
    }

    validateExtension = () => {

        if (this.state.extension && (this.state.extensionMonths != 0 || this.state.extensionMonths != "")) {
            this.setState({
                validExtension: true
            })
            return true;
        } else {
            return false;
        }
    }
    validateFacility = () => {
      
        if ((this.state.typeoffacilities.pl) || (this.state.typeoffacilities.hl) || (this.state.typeoffacilities.pen) ||
            (this.state.typeoffacilities.lease) || (this.state.typeoffacilities.otherLoans) ||
            (this.state.typeoffacilities.tl) || (this.state.typeoffacilities.stl) || (this.state.typeoffacilities.idl) ||
            (this.state.typeoffacilities.otherBusinessLoans)|| (this.state.typeoffacilities.overdrafts)) {
            return true
        } else {

            return false;
        }
       
        
    }

    validateReliefMeasures = () => {
      
        if (((this.state.reliefMeasure.reason1) || (this.state.reliefMeasure.reason2) || (this.state.reliefMeasure.reason3)) &&
            ((this.state.reliefMeasure.reason4) && (this.state.reliefMeasure.otherReasons))){

            return true;
        } else if((this.state.reliefMeasure.reason4) && (this.state.reliefMeasure.otherReasons == "")){
           
            return false;
        } else if (((this.state.reliefMeasure.reason1) || (this.state.reliefMeasure.reason2) || (this.state.reliefMeasure.reason3))
        || (this.state.reliefMeasure.reason4) && (this.state.reliefMeasure.otherReasons !="")){
           
            return true;
        } else if((this.state.reliefMeasure.reason4) && (this.state.reliefMeasure.otherReasons !="")){
            
            return true;
        } else{
            //console.log("hereeee");
            return false;
        }
       
        
    }

    updateMoratorium = (e) => {
        if (e.target.checked) {
            this.setState({
                moratorium: e.target.checked

            })
        } else {
            this.setState({
                moratorium: e.target.checked,
                moratoriumList: {
                    capital: false,
                    interest: false,
                    capital_interest: false
                },
                moratoriumMonths: "",
                validExtension: false

            })
        }
    }

    updateExtension = (e) => {
        if (e.target.checked) {
            this.setState({
                extension: e.target.checked
            })
        } else {
            this.setState({
                extension: e.target.checked,
                extensionMonths: "",
                validMoratatium: false

            })
        }
    }
    handleExtensionValChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChangeReliefMeasure = (e) =>{
        let reliefMeasureCopy = JSON.parse(JSON.stringify(this.state.reliefMeasure))
        if(e.target.name == "otherReasons"){

            reliefMeasureCopy[e.target.name] = e.target.value
        } else if(e.target.name=="reason4"){
            if(!e.target.checked){
                reliefMeasureCopy.otherReasons = "";
                reliefMeasureCopy[e.target.name] = e.target.checked
            } else {
                reliefMeasureCopy[e.target.name] = e.target.checked
            }
        }else {

            reliefMeasureCopy[e.target.name] = e.target.checked
        }

        this.setState({
            reliefMeasure: reliefMeasureCopy
        })

        
    }
    handleMoratoriumValChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleChange = (e) => {

        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onChangeCaptcha(e) {
        this.setState({ captcha: e.target.value });
    }
    handleChangeFacilityType(e) {
        let typeoffacilitiesCopy = JSON.parse(JSON.stringify(this.state.typeoffacilities))
        typeoffacilitiesCopy[e.target.name] = e.target.checked

        this.setState({
            typeoffacilities: typeoffacilitiesCopy
        })
    }
    handleMoratoriumRadioChange = (json) => {
        this.setState({
            moratoriumList: json
        });
    }
    setCaptcha = (code) => {
        this.setState({
            captchaCode: code,
        });
    }
    saveForm = (e) => {
        e.preventDefault(e);
        this.setState({
            captchaValid: true,
            helperText: '',
            error: false,
            branchHelperText: '',
            branchError: false,
            facilityErrorLable: false,
            reqTypeErrorLable: false,
            reliefMeasureErrorLable: false
        });
       
        const validfacility = this.validateFacility();
        const validMoratatium = this.validateMoratatium();
        const validExtension = this.validateExtension();
        const validReliefMeasures = this.validateReliefMeasures();
        if(this.state.captchaCode === this.state.captcha && this.state.branchId != ""){
            this.setState({ helperText: '', error: false });
            this.setState({ branchHelperText: '', branchError: false });
        }

        if ((this.state.captchaCode === this.state.captcha && this.state.branchId != "") && ((validMoratatium || validExtension) && validfacility && validReliefMeasures)) {
            this.setState({ helperText: '', error: false });
            this.setState({ branchHelperText: '', branchError: false });

            var json = {
                name: this.state.name,
                nic: this.state.nic,
                mobileNumber: this.state.mobileNumber,
                email: this.state.email,
                profession: this.state.profession,
                //nameofbusiness: this.state.nameofbusiness,
                accno: this.state.accno,
                branchName: this.state.branchName,
                branchId: this.state.branchId,
                typeoffacilities: this.state.typeoffacilities,
                moratorium: this.state.moratorium,
                moratoriumList: this.state.moratoriumList,
                moratoriumMonths: this.state.moratoriumMonths,
                extension: this.state.extension,
                extensionMonths: this.state.extensionMonths,
                otherInfo: this.state.otherInfo,
                reliefMeasure: this.state.reliefMeasure
            }

            this.props.saveForm(json);

        } else {
            if(validReliefMeasures){
                this.setState({
                    reliefMeasureErrorLable: false
                })
            } else {
                this.setState({
                    reliefMeasureErrorLable: true
                })
            }

            if(validfacility){
                this.setState({
                    facilityErrorLable: false,
                })
            } else {
                this.setState({
                    facilityErrorLable: true
                })
            }

            if(validMoratatium || validExtension){
                this.setState({
                    reqTypeErrorLable: false
                })
            } else {
                this.setState({
                    reqTypeErrorLable: true
                })
            }
            /*
            if((validReliefMeasures && validfacility && (validMoratatium || validExtension))){
                this.setState({
                    reqTypeErrorLable: false,
                    facilityErrorLable: false,
                    reliefMeasureErrorLable: false
                })
            } else if ((validfacility && (validMoratatium || validExtension))) {
                this.setState({
                    reqTypeErrorLable: false,
                    facilityErrorLable: false,
                    reliefMeasureErrorLable: true
                })
            } else if ((validReliefMeasures && (validMoratatium || validExtension))) {
                    this.setState({
                        reqTypeErrorLable: false,
                        reliefMeasureErrorLable: false,
                        facilityErrorLable: true,
                    })
            } else {
                if (!validfacility && !(validMoratatium || validExtension)) {
                    this.setState({
                        reqTypeErrorLable: true,
                        facilityErrorLable: true
                    })
                } else if (!validfacility) {
                    this.setState({
                        facilityErrorLable: true,
                        //reqTypeErrorLable:false,
                    })
                } else if (!(validMoratatium || validExtension)) {
                    this.setState({
                        reqTypeErrorLable: true,
                    })


                }
            } */

                if (this.state.captchaCode != this.state.captcha && this.state.branchId == "") {
                    this.setState({ branchHelperText: 'Please select the branch', branchError: true });
                    this.setState({ helperText: 'Code does not match', error: true });
                    var l = document.getElementById('retryButton');
                    l.click();


                } else if (this.state.captchaCode != this.state.captcha) {
                    this.setState({ helperText: 'Code does not match', error: true });
                    this.setState({ branchHelperText: '', branchError: false });
                    var l = document.getElementById('retryButton');
                    l.click();

                } else if( this.state.branchId == "") {
                    this.setState({ branchHelperText: 'Please select the branch', branchError: true });
                 
                } 
                else {
                    this.setState({ branchHelperText: '', branchError: false });
                    this.setState({ helperText: '', error: false });
                  
                }
            }
            
        
    }
    handleBranchChange = (e, obj) => {
        this.setState({
            branchId: e.target.value,
            branchName: obj.props.name
        });
    }

    resetErrorState = () => {
        this.props.resetErrorState()
    }
    handleRadioChange = (e) => {
        this.setState({ selRadioValue: e.target.name });
        this.handleList(e.target.name)
        
    };
    handleList = (value) => {
        let reliefMeasureCopy = JSON.parse(JSON.stringify(this.state.reliefMeasure))
    
        if (value === 'reason1') {
            reliefMeasureCopy['reason1'] = true
            reliefMeasureCopy['reason2'] = false
            reliefMeasureCopy['reason3'] = false
            reliefMeasureCopy['reason4'] = false
            reliefMeasureCopy.otherReasons = ''
        
        } else if (value === 'reason2') {
            reliefMeasureCopy['reason2'] = true
            reliefMeasureCopy['reason1'] = false
            reliefMeasureCopy['reason3'] = false
            reliefMeasureCopy['reason4'] = false
            reliefMeasureCopy.otherReasons = ''

        } else if (value === 'reason3') {
            reliefMeasureCopy['reason3'] = true
            reliefMeasureCopy['reason1'] = false
            reliefMeasureCopy['reason2'] = false
            reliefMeasureCopy['reason4'] = false
            reliefMeasureCopy.otherReasons = ''

    } else {
            reliefMeasureCopy['reason4'] = true
            reliefMeasureCopy['reason1'] = false
            reliefMeasureCopy['reason2'] = false
            reliefMeasureCopy['reason3'] = false

        }

        this.setState({
            reliefMeasure:reliefMeasureCopy 
        })
    }

    render() {
        const moratorium = this.state.moratorium;
        const extension = this.state.extension;
        const branches = this.props.branches;
        const success = this.props.success;
        const error = this.props.error;
        const loading = this.props.loading;
        const refNo = this.props.refNo;
        const wave = this.props.wave;
        const circular = this.props.circular;
        const selectedValue = this.state.selRadioValue
        return (
            <>
                <Container component="main" maxWidth="xs">
                    <div className="sucess-dialog">
                        {success ? <SucessDialog
                            refNo={refNo}
                        />
                            : null}
                    </div>
                    <div className="error-dialog">
                        {error ? <ErrorDialog
                            resetErrorState={this.resetErrorState}
                        /> : null}
                    </div>
                    <CssBaseline />
                    <div className="paper">
                        <h3> <center>RELIEF MEASURES TO ASSIST COVID-19 AFFECTED INDIVIDUALS AND BUSINESSES UNDER CBSL
                            CIRCULAR {circular.toUpperCase()} </center>
                        </h3>
                        <div><center>
                            <Avatar className="avatar">
                                <AccountBalanceWalletIcon color="primary" />
                            </Avatar>
                        </center>
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <center>
                                <Typography component="h1" variant="h5" fontFamily="sans-serif" className="lbl-cbc">
                                    Request Form
                        </Typography>
                            </center>
                        </div>
                        <form className="action-form" onSubmit={this.saveForm}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        autoComplete="name"
                                        name="name"
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="name"
                                        label="Name with Initials / Business Name"
                                        autoFocus
                                        onChange={(e) => this.handleChange(e)}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="nic"
                                        label="NIC Number / Business Registartion Number"
                                        name="nic"
                                        autoComplete="nic"
                                       // inputProps={{ className: "input-nic", pattern: "^([0-9]{9}[x|X|v|V]|[0-9]{12})$" }}
                                        onChange={(e) => this.handleChange(e)}
                                        //inputProps={{ maxLength: 30 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="mobileNumber"
                                        type="number"
                                        label="Mobile Number"
                                        name="mobileNumber"
                                        autoComplete="mobileNumber"
                                        onChange={(e) => {
                                            if (e.target.value.length > 15) {
                                                e.target.value = e.target.value.slice(0, 15)
                                            };
                                            this.handleChange(e)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="email"
                                        type="email"
                                        label="Email Address"
                                        name="email"
                                        //inputProps={{ className:"input-email", pattern: "/^.{6,7}$/" }}
                                        autoComplete="email"
                                        onChange={(e) => this.handleChange(e)}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="profession"
                                        label="Profession/Nature of Business"
                                        name="profession"
                                        autoComplete="profession"
                                        onChange={(e) => this.handleChange(e)}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        // id="nameofbusiness"
                                        label="Name of Business and Business Registration No (only if applicable )"
                                        name="nameofbusiness"
                                        autoComplete="nameofbusiness"
                                        onChange={(e) => this.handleChange(e)}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="accno"
                                        label="Main Account No"
                                        type="number"
                                        name="accno"
                                        //inputProps={{ className:"input-acc", pattern: "^.{0,10}$"}}
                                        autoComplete="accno"
                                        onChange={(e) => {
                                            if (e.target.value.length > 10) {
                                                e.target.value = e.target.value.slice(0, 10)
                                            };
                                            this.handleChange(e)
                                        }}
                                        // onChange={(e) => this.handleChange(e)}
                                        // onInput={(e)=>{ 
                                        //     e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,10)
                                        // }}
                                        min={10}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        id="branch"
                                        select
                                        required
                                        fullWidth
                                        name="branch"
                                        label="Lending Branch"
                                        onChange={(event, value) => this.handleBranchChange(event, value)}
                                        getOptionLabel={(option) => option.branchName}
                                        helperText={this.state.branchHelperText}
                                        error={this.state.branchError}
                                        variant="outlined"
                                    >
                                        {branches.map((option) => (
                                            <MenuItem key={option.branchId} name={option.branchName} value={option.branchId}>
                                                {option.branchName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <Lable className="lbl-cbc"><b>Reasons for requesting relief measures*</b></Lable>
                                </Grid>
                                <RadioGroup value={selectedValue} onChange={(e) => this.handleRadioChange(e)}>
                                    <Grid item xs={12}>
                                    <table>
                                        <tr>
                                            <td>
                                            <Lable>I. </Lable> <Lable>Drop in income / salary due to COVID19 pandemic </Lable> 
                                            </td>
                                            <td>
                                                <Radio name="reason1" color="primary"
                                                value='reason1'
                                                //onChange={(e) => this.handleChangeReliefMeasure(e)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                            <Lable>II. </Lable> <Lable> Loss of employment</Lable>
                                            </td>
                                            <td>
                                                <Radio name="reason2" color="primary"
                                                value='reason2'
                                               // onChange={(e) => this.handleChangeReliefMeasure(e)}
                                               />
                                            </td>
                                        </tr>
                                        <tr>
                                            
                                            <td>
                                            <Lable>III. </Lable><Lable> Drop in cash flows / business turnover (income) due to COVID19 pandemic</Lable>
                                            </td>
                                            <td>
                                                <Radio name="reason3" color="primary"
                                                value='reason3'
                                                //onChange={(e) => this.handleChangeReliefMeasure(e)}
                                                />
                                            </td>

                                        </tr>
                                        <tr>
                                            
                                            <td>
                                            <Lable>IV. </Lable> <Lable> Other reasons </Lable>
                                            </td>
                                        <td>
                                            <Radio name="reason4" color="primary"
                                            value='reason4'
                                            //onChange={(e) => this.handleChangeReliefMeasure(e)}
                                            
                                            />
                                        </td>

                                        </tr>
                                    </table>  
                                    </Grid>
                                </RadioGroup>
                                {this.state.reliefMeasure.reason4?
                                <Grid item xs={12}>
                                <Lable><Box fontStyle="italic" fontSize="12px">State other reasons</Box></Lable>
                                    <br/>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        id="otherReasons"
                                        label="Please provide details of other reasons"
                                        name="otherReasons"
                                        autoComplete="otherReasons"
                                        value={this.state.reliefMeasure.otherReasons}
                                        disabled={!this.state.reliefMeasure.reason4}
                                        visible={false}
                                        multiline
                                        rows={3}
                                        rowsMax={4}
                                        inputProps={{ maxLength: 200 }}
                                        onChange={(e) => this.handleChangeReliefMeasure(e)}
                                        helperText={`Characters count (${this.state.reliefMeasure.otherReasons.length}/200)`}
                                    />
                                    </Grid>
                                  :null}
                                    {this.state.reliefMeasureErrorLable ? <Lable><Box className="relief-Measure-error" fontStyle="italic" color='red' fontSize="14px">Please provide other reasons for requesting relief measures</Box></Lable> : null}
                                    
                                <Grid item xs={12}>
                                    <Lable className="lbl-cbc"><b>Type of facility for which relief measures requested for*</b></Lable>
                                </Grid>
                                <Grid item xs={12} className="lbl-cbc">For Retail Borrowers</Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="pl" />}
                                            label="Personal Loan"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="hl" />}
                                            label="Housing Loan"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="pen" />}
                                            label="Overdrafts"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="lease" />}
                                            label="Lease"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="otherLoans" />}
                                            label="Other Loans"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                    <Lable><Box fontStyle="italic" fontSize="12px">(state the type of loans in <b>"Further Information"</b>)</Box></Lable>
                                </Grid>
                                {/* ================ */}
                                <Grid item xs={12}className="lbl-cbc">For Business Borrowers</Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="tl" />}
                                            label="Term Loan"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="stl" />}
                                            label="Short Term Loans"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="idl" />}
                                            label="Import Demand Loans"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <FormGroup>
                                    <FormControlLabel
                                            control={<Checkbox color="primary" name="overdrafts" />}
                                            label="Overdrafts"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormGroup>

                                        <FormControlLabel
                                            control={<Checkbox color="primary" name="otherBusinessLoans" />}
                                            label="Other Business Loans"
                                            onChange={(e) => this.handleChangeFacilityType(e)}
                                        />
                                
                                    </FormGroup>
                                    <Lable><Box fontStyle="italic" fontSize="12px">(state the type of loans in <b>"Further information"</b>)</Box></Lable>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    {this.state.facilityErrorLable ? <Lable><Box className="facility-type-error" fontStyle="italic" color='red' fontSize="14px">Please select product type/s  
                                    from Type of Facility / Loan, Deferment  requested for</Box></Lable> : null}
                                </Grid>
                                {/* ================ */}
                                <Grid item xs={12}>
                                    <Lable className="lbl-cbc"><b>Nature of relief measures requested For*</b></Lable>
                                </Grid>

                                <Grid item xs={12} >
                                    <Grid item xs={12} >

                                        <Grid item xs={12} sm={12}>

                                            <FormControlLabel value="moratorium"
                                                control={<Checkbox color="primary"/>}
                                                label="Deferment"
                                                className="lbl-cbc"
                                                onChange={(e) => this.updateMoratorium(e)}
                                            />
                                            <Lable><Box fontStyle="italic" fontSize="12px">Deferment of your monthly/periodical repayment of loan</Box>
                                            </Lable>
                                        </Grid>
                                        {moratorium ?
                                            <>
                                                <Grid item xs={12} sm={12}>
                                                    <Moratorium
                                                        handleChange={this.handleChange}
                                                        handleMoratoriumRadioChange={this.handleMoratoriumRadioChange}
                                                        handleMoratoriumValChange={this.handleMoratoriumValChange}
                                                    />
                                                </Grid>

                                            </> : null
                                        }

                                    </Grid>
{/* 
                                    <Grid item xs={12}>
                                        <Grid item xs={12} sm={12}>
                                            <FormControlLabel value="extension" control={<Checkbox color="primary"/>}
                                                label="EXTENSION"
                                                className="lbl-cbc"
                                                onChange={(e) => this.updateExtension(e)}
                                            />
                                            <Lable><Box fontStyle="italic" fontSize="12px">Extending the Maturity date of your revolving facilities eg- IDL / STL)</Box>
                                            </Lable>
                                            <div><br /></div>
                                        </Grid>
                                        {extension ?
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <Extension
                                                        handleChange={this.handleChange}
                                                        handleExtensionValChange={this.handleExtensionValChange}
                                                    />
                                                </Grid>

                                            </> : null
                                        }
                                    </Grid> */}

                                    {this.state.reqTypeErrorLable ? <Lable><Box className="req-nature-error" fontStyle="italic" color='red' fontSize="14px">Incomplete selection for Moratorium</Box></Lable> : null}

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        id="otherInfo"
                                        label="Further Information"
                                        name="otherInfo"
                                        autoComplete="otherInfo"
                                        multiline
                                        rows={3}
                                        rowsMax={4}
                                        inputProps={{ maxLength: 500 }}
                                        onChange={(e) => this.handleChange(e)}
                                        helperText={`Characters count (${this.state.otherInfo.length}/500)`}
                                    />
                                    <br />
                                    <Lable><Box fontStyle="italic" fontSize="12px">(If you have more than one facility from the selected product/s or marked <b>"Other"</b>,
                                    please give more details. i.e Type of Loan, Amount Granted etc...)</Box>
                                    </Lable>
                                    <br/>
                                    <Lable> <Box fontSize="16px"><u>Declaration</u></Box></Lable>
                                    <br/>
                                    <Lable><Box fontSize="14px">I/we am/are aware that the interest will be accrued at the contracted rate of 
                                    interest during the deferment period on the facilities for which 
                                    I/we have requested for the above relief.
                                    I/we agree to pay the interest / capital / interest + capital falling due during 
                                    the period of deferment at the end of such period or by converting same 
                                    to a term loan at the interest rates specified in the CBSL Circular  {circular} </Box>
                                    </Lable>
                                    <br/>
                                    <Lable><Box fontSize="14px">I / we acknowledge that these terms and 
                                    conditions are in addition to the terms and conditions 
                                    already agreed, by me/ us in previous connected letters of 
                                    offer and in case of any contradiction on the terms and 
                                    conditions relating to the facilities/ concessions offered 
                                    herein, will supersede the terms and conditions of the previous letters of offer.
                                    </Box>
                                    </Lable>


                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="captcha"
                                        label="Captcha"
                                        name="captcha"
                                        autoComplete="captcha"
                                        onChange={(e) => this.onChangeCaptcha(e)}
                                        error={this.state.error}
                                        helperText={this.state.helperText}
                                        inputProps={{ maxLength: 5 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Captcha
                                        setCaptcha={this.setCaptcha}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Lable><Box fontStyle="italic" fontSize="12px">Please enter the verification code shown and press<b>"Submit"</b>.</Box></Lable>
                                </Grid>
                                <Grid item xs={12}>
                                </Grid>
                                <div><br /></div>
                                <div><br /></div>
                            </Grid>

                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                type="submit"
                                className="form-submit"
                            >
                                Submit
                            </Button>
                        </form>
                    </div>
                </Container>
                <div className="pre-loader">
                    {loading ?
                        <div>
                            <div className="loading"><img src={Pulse}></img>
                            </div>
                        </div>
                        : null}
                </div>
            </>
        );
    }
}
export default (ReliefFormComponent);